export enum ChangeType {
	Add = 'ADD',
	Update = 'UPDATE',
	Remove = 'REMOVE',
}
